import React from 'react'
import { Input, BaseForm, Select } from '../../../../components/Form'
import { getMessage } from '../../../../lib/translator'

const STATUS_OPTIONS = [
  { text: getMessage('whitelistDomain.filter.status.all'), value: 'all' },
  {
    text: getMessage('whitelistDomain.filter.status.enabled'),
    value: 'active',
  },
  {
    text: getMessage('whitelistDomain.filter.status.disabled'),
    value: 'inactive',
  },
]

class WhitelistDomainFilters extends BaseForm {
  render() {
    const { Form } = this.components
    const { SubmitButton, ClearButton } = this.buttons

    return (
      <Form className="whitelist-domain-filters">
        <div className="form-fields">
          <Input
            label={getMessage('whitelistDomain.filter.domain')}
            placeholder={getMessage(
              'whitelistDomain.filter.domain.placeholder'
            )}
            name="domain"
            type="text"
            {...this.generateStateMappers({
              stateKeys: ['domain'],
              loseEmphasisOnFill: true,
            })}
          />
          <Select
            name="enabled"
            label={getMessage('whitelistDomain.filter.status.label')}
            placeholder={getMessage(
              'whitelistDomain.filter.status.placeholder'
            )}
            options={STATUS_OPTIONS}
            {...this.generateStateMappers({
              stateKeys: ['status'],
              loseEmphasisOnFill: true,
              valueKey: 'value',
              textKey: 'text',
            })}
          />
        </div>
        <SubmitButton>
          {getMessage('whitelistDomain.filter.submit')}
        </SubmitButton>
        <ClearButton>{getMessage('whitelistDomain.filter.clear')}</ClearButton>
      </Form>
    )
  }
}

export default WhitelistDomainFilters
